import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';
import './Collapsible.scss';
import { Icon, SIZE } from '../icon/Icon';
import { SvgCaretDown } from '../../index';
export function Collapsible(props) {
    const bodyRef = useRef(null);
    const handleHeaderClick = (e) => {
        props.onClick?.(e, { data: props.data });
    };
    const handleBodyTransitionEnd = useCallback(() => {
        if (bodyRef.current && !props.isClosed) {
            bodyRef.current.style.overflow = 'visible';
        }
    }, [props.isClosed]);
    useLayoutEffect(() => {
        if (bodyRef.current && props.isClosed) {
            bodyRef.current.style.overflow = 'hidden';
        }
    }, [props.isClosed]);
    return (_jsxs("section", { className: classNames({
            'sg-collapsible': true,
            'sg-collapsible-isClosed': props.isClosed,
        }), children: [_jsxs("header", { className: 'sg-collapsible--head', onClick: handleHeaderClick, "data-test-id": props.testId ? `${props.testId}-head` : undefined, children: [_jsx("div", { className: 'sg-collapsible--headContent', "data-test-id": props.testId ? `${props.testId}-headContent` : undefined, children: props.headElement ?? _jsx("span", { className: 'sg-collapsible--label', children: props.label }) }), _jsx("div", { className: 'sg-collapsible--arrow', children: _jsx(Icon, { element: _jsx(SvgCaretDown, {}), size: SIZE.MED }) })] }), _jsx("div", { ref: bodyRef, className: 'sg-collapsible--body', onTransitionEnd: handleBodyTransitionEnd, "data-test-id": props.testId ? `${props.testId}-body` : undefined, children: _jsx("div", { className: 'sg-collapsible--content', children: props.children }) })] }));
}
//# sourceMappingURL=Collapsible.js.map